import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  gap: ${({ theme }) => theme.spacing.values.base};
  justify-content: flex-end;
  flex-wrap: wrap;
  padding-top: ${({ theme }) => theme.spacing.values.double};
  @media screen and (max-width: 1080px) {
    width: ${({ theme }) => theme.spacing.utils.pxToRem(380)};
  }
`;

export const SmsTitle = styled.div`
  align-items: center;
  color: ${colors.textSecondary};
  display: flex;
  justify-content: space-between;
  padding: ${pxToRem(18)} ${spacing.threeQuarter};
  width: 100%;
`;
